import { computeVolumeProfile } from "../utils";
const VolumeProfile = {
    name: "VolumeProfile",
    compute: (bars, priceTickSize = 0.01, range) => {
        return computeVolumeProfile(bars, priceTickSize, range);
    },
    render: () => undefined,
};
export default VolumeProfile;
